// extracted by mini-css-extract-plugin
export default {"tableLoaderContainer":"tableLoader_tableLoaderContainer__+BztZ","tableLoaderCircle":"tableLoader_tableLoaderCircle__eyi5v","spin":"tableLoader_spin__R8md4"};